import { createStore } from "redux";

const reducer = (state, action) => {
    switch(action.type){
    	case "SET_USER_NAME":
			return {
				...state,
				username: action.username
			};
    	case "SET_MODAL_CONTENT":
			return {
				...state,
				modalContent: action.modalContent
			};
    	case "SET_FILTERS_CONTENT":
			return {
				...state,
				filtersContent: action.filtersContent
			};
    	case "SET_SELECTED_FILTERS":
			return {
				...state,
				selectedFilters: action.selectedFilters
			};
		case "SET_MENU":
			return {
				...state,
				menu: action.menu
			};
		case "SET_USERS":
			return {
				...state,
				users: action.users
			};
		case "SET_CLIENTS":
			return {
				...state,
				clients: action.clients
			};

			case "SET_SELECTED_CLIENTS":
			return {
				...state,
				selectedClients: action.selectedClients
			};
		case "SET_SELECTED_USERS":
			return {
				...state,
				selectedUsers: action.selectedUsers
			};
		case "SET_CLIENTS_PAGINATION":
				return {
					...state,
					clientsPagination: action.clientsPagination
				};
		case "SET_BILLS_PAGINATION":
			return {
				...state,
				billsPagination: action.billsPagination
			};
	default:
		break;
    }

    return state;
}


const initialState = {
    menu: {
	    options: [
		    {name: 'Panel de control', sub: [
				{name: 'Fichar', url: '/dashboard', sub:[]},
				{name: 'Ver fichajes', url: '/signings', sub:[]},
				{name: 'Agenda', url: '/schedule', sub:[]},
				{name: 'Usuarios', url: '/users', sub:[]},
				{name: 'Delegaciones', url: '/locations', sub:[]}
			]},
		    {name: 'Clientes', url: '/clients', sub:[]},
		    {name: 'Almacén', sub:[
				{name: 'Tipos de artículo', url: '/article_types', sub:[]},
				{name: 'Artículos', url: '/articles', sub:[]},	
				{name: 'Reservas', url: '/bookings', sub:[]},	   
		    ]},
			{name: 'Facturación', sub:[
				{name: 'Tipos de impuesto', url: '/taxes', sub:[]},
				{name: 'Tipos de operación', url: '/operations', sub:[]},
				{name: 'Facturas', url: '/bills', sub:[]},
		    ]},
			{name: 'Informes', url: '/reports', sub:[]}
        ]
    },
    users: [
    ],
    filters: {
    },
    selectedFilters:{
	    users:[],
	    dateRange: {start: '', end: ''}
    },
    clients:{
    },
    selectedClients:{
	    clients:[]
    },
    selectedUsers:{
	    users:[]
    },
	clientsPagination: {},
	billsPagination: {},
    username: 'Sin usuario'
}

const composeEnhancers =  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__();

export default createStore(reducer, initialState, composeEnhancers);
